import { useContext } from 'react';
import { AppCompatibilityContext } from '../context/AppCompatibilityContextValue';

/**
 * Reads the live maintenance state owned by AppCompatibilityProvider. Returns
 * `null` when the backend is not signalling maintenance. AppLayout consumes this
 * to render the sticky <MaintenanceBanner/> under its header (C.6).
 */
export const useMaintenanceState = () => {
  const context = useContext(AppCompatibilityContext);

  if (!context) {
    throw new Error('useMaintenanceState must be used within AppCompatibilityProvider');
  }

  return context.maintenance;
};
